





































import { Component, Vue } from 'vue-property-decorator';
import { LINKS } from '@/const/links';

@Component({
  name: 'survey-page-footer',
})
export default class SurveyPageFooter extends Vue {
  private url = LINKS.CENTER_AI;

  private get isCustomFont() {
    return this.$store.getters.isVox;
  }
}
